import React, {useState, useEffect, useRef, useCallback, useContext} from 'react'
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { AuthContext } from "../../components/Auth/AuthDataProvider.jsx";
import Card from '../../components/Card/Card.jsx';
import OldTable from '../../components/Table/OldTable.jsx';
import CustomInput from '../../components/CustomFields/CustomInput.jsx';
import CustomSwitch from '../../components/CustomFields/CustomSwitch.jsx';
import CustomDialog from '../../components/Dialog/CustomDialog.jsx';
import CustomDialog2 from '../../components/Dialog/CustomDialog2.jsx';
import apiUtil from "../../api/apiUtil.jsx";
import Api from "../../api/api.jsx";
import ldsApi from '../../api/ldsApi.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faMagnifyingGlass, faPlus, faEye, faFilePdf, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Container, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import CustomDateRangePicker from '../../components/CustomFields/CustomDateRangePicker.jsx';
import wmsApi from '../../api/wmsApi.jsx';
import dataUrlToBlob from 'dataurl-to-blob'
import evfyLogo from '../../assets/img/evfy-logo2.png'
import jsPDF from "jspdf";
import 'jspdf-autotable';
import moment from 'moment';
import {RoleAccessService} from '../../data/role-access'; 
import ResendMail from '../../assets/img/icons/send-email.png'
import CustomCheckbox from '../../components/CustomFields/CustomCheckbox.jsx';
/**
 * 
 * update on input type number change. 
 * dedicated component, so the whole table won't be refreshed
 */

export const ClientInvoice = props => {
  const refTableSearch = useRef();
  const refTable = useRef();
  const customerPhoneRef = useRef()
  const customerEmailRef = useRef()
  const customerAddressRef = useRef()
  const customerInvoiceRef = useRef()

  let grantedAccess = new RoleAccessService();
  let role = window.localStorage.getItem('uniqueRolePermissions');
  // const { currentRole } = this.context;
  let currentRole = window.localStorage.getItem('current_role');
  let userInfo = JSON.parse(window.localStorage.getItem('user')).result

  const {accessToken} = useContext(AuthContext)
  const [key, setKey] = useState(Date.now());
  const [page, setPage] = useState(1);
  const [searchVal, setSearchVal] = useState("");
  const [total, setTotal] = useState(0);
  const [rowData, setRowData] = useState(null);
  const [limit, setLimit] = useState(20);
  const [openDialog, setOpenDialog] = useState(false);
  const [invoiceDialog, setInvoiceDialog] = useState(false);
  const [openDialogItem, setOpenDialogItem] = useState(null);
  const [data, setData] = useState([])
  const [customers, setCustomers] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [customerId, setCustomerId] = useState(null)
  const [customer, setCustomer] = useState(null)
  const [department, setDepartment] = useState('')
  const [billingEamil, setBillingEamil] = useState('')
  const [billingDate, setBillingDate] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [progress, setProgress] = useState(null)
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false)
  
  const [pdfUrl, setPdfUlr] = useState(null)
  const [rangeDate, setRaneDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [openInvoicePreviewDialog, setOpenInvoicePreviewDialog] = useState(false)
  const [customerPhone, setCustomerPhone] = useState('')
  const [customerEmail, setCustomerEmail] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [invoiceNumber, setInvoiceNumber] = useState(null)
  const [invoiceNew, setInvoiceNew] = useState(null)
  const [previewData, setPreviewData] = useState(null)
  const [ccEmails, setCcEmails] = useState('')
  const [notifyCustomer, setNotifyCustomer] = useState(true)
  const [resentMail, setResentMail] = useState('')
  const [multiBillingEmail, setMultiBillingEmail] = useState([]);
  const [billingEmail, setBillingEmail] = useState('');
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    callReadApi()
    callCustomerApi()
  }, [])


  const callReadApi = (search = '' , change_page) => {
    setIsInvoiceLoading(true)
    let param = {
        page: change_page ? change_page : page,
        take: limit,
        search: search ? search.trim() : search,
        customer: true,
        sort: "latest"
      };

      ldsApi.read("client_driver_billings", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          setData(result)
          setTotal(data.total)
          setIsInvoiceLoading(false)
          }, (error, type) => {
            apiUtil.toast(error,  'warning', 'error')
            setIsInvoiceLoading(false)
          });
      });
  }
  
  const handleInputChange = (event) => {
    setBillingEmail(event.target.value);
  };

  const handleInputKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      const newInputValue = billingEmail.trim();
      if(isValidEmail(newInputValue) == false) {
        apiUtil.toast('Invalid email address', 'warning', 'error');
        return;        
      }
      if (newInputValue && isValidEmail(newInputValue) && !multiBillingEmail.includes(newInputValue)) {
        setMultiBillingEmail([...multiBillingEmail, newInputValue]);
        setBillingEmail('');
        setIsValid(true);
      } else {
        setIsValid(false);   
      }
    }
  };
  
  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleValueDelete = (valueToDelete) => {
    const filtering = multiBillingEmail.filter(value => value !== valueToDelete)
    setMultiBillingEmail(filtering);
    if(filtering.length == 0) {
      setCcEmails('');   
    }
  };

  const callCustomerApi = () => {
    setIsLoading(true)
    let param = {
      is_active: true,
      invoice_light_data : true,
      };

      wmsApi.read("customers", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          setCustomers(result.sort((a, b) => {
            const nameA = a.company_name?.toUpperCase(); // ignore upper and lowercase
            const nameB = b.company_name?.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
          }))
          setIsLoading(false)
          }, (error, type) => {
            setIsLoading(false)
          });
      });
  }
  const callUpdateIsActiveApi = (row, callback = null) => {
    setIsLoading(true)
    let params = {
      is_paid: row.is_paid
    }
    ldsApi.update('client_driver_billings/' + row.id, params, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {
        if(callback){
          callback();
        }
        setIsLoading(false)
      }, (error, type) => {
        setIsLoading(false)
      });
  });
  }

  const callCreateApi = (callback = null, is_preview = null) => {
    let startDate = rangeDate && rangeDate.startDate ? moment(rangeDate && rangeDate.startDate).format(apiUtil.getDefaultDateFormat()) : '';
    let endDate =  rangeDate && rangeDate.endDate ? moment(rangeDate && rangeDate.endDate).format(apiUtil.getDefaultDateFormat()): '';
    setIsLoading(true)
    let params = {
      customer_id: customerId,
      department: department,
      email: multiBillingEmail,
      due_date: billingDate,
      pdf_url:  pdfUrl,
      start_date: startDate,
      end_date: endDate,
      is_preview: is_preview,
      invoice_number: (invoiceNew == invoiceNumber) ? '' : invoiceNumber,
      customer_phone: customerPhone,
      customer_email: multiBillingEmail.join(','),
      customer_address: customerAddress,
      cc_emails: ccEmails,
      notify_customer: notifyCustomer,
    }
    ldsApi.create('client_driver_billings', params, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {

        
        if(callback){
          callback(data);
        }
        setIsLoading(false)
      }, (error, type) => {
        if(error && error !== ''){
            apiUtil.toast(error, 'warning', 'error');
        }
        setIsLoading(false)
      });
  });
  }

  const callResendApi = (resent_data, callback = null) => {
    setIsLoading(true)
    let params = {
      customer_id: resent_data?.customer_id,
      department: resent_data?.department,
      email: multiBillingEmail,
      due_date: resent_data?.due_date,
      pdf_url:  resent_data?.pdf_url,
      start_date: resent_data?.start_date,
      end_date: resent_data?.end_date,
      invoice_number: resent_data?.invoice_number,
      customer_phone: resent_data?.customer?.contact_no1,
      customer_email: multiBillingEmail.join(','),
      customer_address: resent_data?.customer?.customer_addresses,
      cc_emails: ccEmails,
      notify_customer: notifyCustomer,
    }
    ldsApi.create('client_driver_billings_resend_mail', params, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {

        
        if(callback){
          callback(data);
        }
        setIsLoading(false)
      }, (error, type) => {
        if(error && error !== ''){
            apiUtil.toast(error, 'warning', 'error');
        }
        setIsLoading(false)
      });
  });
  }

  const callDeleteApi = (row, callback = null) => {
    setIsLoading(true);
    let param = {
      destroy_all: true,
    };
    ldsApi.delete('client_driver_billings/' + row.id, param, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {
        setIsLoading(false);
        if(callback){
          callback();
        }
      }, (error, type) => {
        setIsLoading(false);
        if(callback){
          callback();
        }
      });
  });
  }


  /* TABLE */
  const CustomTable = () => {
    return <OldTable 
      ref={refTable}
      isLoading={isInvoiceLoading}
      className={'job-table-list' }  
      limit={limit}
      isDraggable={false}
      // grouping={true}
      page={page}
      total={total}
      defaultExpanded={true}
      selection={ true}
      data={data}
      onPageChange={(page, size) => {
        setLimit(size);
        setPage(page);
        callReadApi(refTableSearch.current.state.value, page);
      }}
      onSelectionChange={(rows, column)=>{
        setRowData(rows);
      }}
      columns={[
        { 
          title: "Clients’ Name", 
          field: "customer",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150            
          },
          customSort: (a,b) => (a.customer && a.customer.company_name ? a.customer.company_name : '').toString().toLowerCase().trim().localeCompare((b.customer && b.customer.company_name? b.customer.company_name : '').toString().toLowerCase().trim()),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>{(row && row.customer ) ? row.customer.company_name.replace(/\s/g, '\u00A0') : ''}</span>;
            } else {
              return row;
            }
          }
        },  
        { 
          title: "Billing Email", 
          field: "email",
          cellStyle: {
            minWidth: 250,
            maxWidth: 250            
          },
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>{(row && row.email ) ? row.email : ''}</span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Invoice Number", 
          field: "invoice_number",
          cellStyle: {
            minWidth: 200,
            maxWidth: 200            
          },
        },
        { 
          title: "Contact Number", 
          field: "phone_number",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150            
          },
          customSort: (a,b) => (a.customer && a.customer.contact_no1 ? a.customer.contact_no1 : '').toString().toLowerCase().trim().localeCompare((b.customer && b.customer.contact_no1? b.customer.contact_no1 : '').toString().toLowerCase().trim()),
          render: (row, type) => {
            if(type === 'row'){
              return (row && row.customer ) ? row.customer.contact_no1 : '';
            } else {
              return row;
            }
          }
        },
        { 
          title: "Invoice Date", 
          field: "due_date",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150            
          },
          render: (row, type) => {
            if(type === 'row'){
              if(row && row.created_at) {
                var splitdate = row.due_date.split(" ")
                // return splitdate[0];
                return moment(splitdate[0]).format(apiUtil.getImportDateFormat());
              } else {
                return '';
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Status", 
          field: "status",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150            
          },
          sorting: false,
          render: (row, type) => {
            if(type === 'row'){
              if(row && row.due_date) {
                var now = moment();
                var current_date = moment(now, "YYYY-MM-DD").unix()
                var due_date = moment(row.due_date, "YYYY-MM-DD").add(1, 'M').unix();
                if(row.is_paid) {
                  return <span style={{color: "green"}}>Paid</span>
                } else {
                  if (current_date < due_date) {
                    return <span style={{color: "orange"}}>Pending</span>
                  } else {
                    return <span style={{color: "red"}}>Overdue</span>
                  }
                }
              } else {
                return '';
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Paid?", 
          align: 'paid',
          cellStyle: {
            minWidth: 150,
            maxWidth: 150            
          },
          sorting: false,
          render: (row) => {
            
            return <Box>
              <Grid container justify={'center'}>
                <Box clone>
                  <Grid item xs={'auto'}>
                  <CustomSwitch 
                      checked={row.is_paid}
                      disabled={!grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Edit') ? true: false}
                      onChange={(isChecked) => {
                        row.is_paid = isChecked;
                        callUpdateIsActiveApi(row, () => {
                          callReadApi(refTableSearch.current.state.value);
                          apiUtil.toast('Successfully Updated!', 'check_circle');
                        });
                      }}
                    />
                  </Grid>
                </Box>
              </Grid>
            </Box>
          }
        },
        { 
          title: "Actions",
          field: "actions",
          cellStyle: {
            minWidth: 180,
            maxWidth: 180,
          },
          // align: 'center',
          sorting: false,
          render: (row) => {
            return <Container fluid className="d-flex justify-content-around align-items-center">
                  <span
                  onClick={()=>{
                    setInvoiceDialog(true);
                    setResentMail(row)
                    setBillingEamil(row.email)

                    if(row.email && row.email.trim() != '') {
                      setMultiBillingEmail([...multiBillingEmail,...row.email.split(',')]);
                    }

                    setCustomerId(row.customer_id)
                    setDepartment(row.department)
                    var splitdate = row.due_date.split(" ")

                    setBillingDate(moment(splitdate[0]).format('YYYY-MM-DD'))
                    setRaneDate({
                      startDate: row.start_date,
                      endDate: row.end_date,
                    })
                  }}
                  ><img src={ResendMail} /></span>
                  <a className="text-decoration-none" 
                  href={ row.pdf_url} 
                  target={"_blank"}
                  // onClick={()=> {
                  //   callExportInvoicePDF();
                  // }}
                  > <FontAwesomeIcon icon={faFilePdf} style={{fontSize:"18px", color : row.pdf_url ? "#007cde" :"#007cdea3"}}/></a>
                  { grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Details') && <FontAwesomeIcon icon={faEye} style={{fontSize:"18px"}} className="primary-color"
                  onClick={()=>{
                    props.history.push({
                      pathname: '/invoice/client/details',
                      state: {
                        id: row.id,
                        // orders: row.orders,
                        client_name: (row && row.customer ) ? row.customer.company_name : ''
                      }
                    });
                  } }
                  />}
                  {(grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice Delete') && currentRole != "BD Admin") && <span
                  onClick={()=>{
                    setOpenDialog(true)
                    setOpenDialogItem(row)
                  }}
                  ><FontAwesomeIcon icon={faTrashCan} style={{fontSize:"18px"}} className="danger-color"/></span>}
            </Container>
          }
        },
      ]}
    />
  }

  const getQty = (packages) => {
    let qty = 0
    if (packages.length > 0 ) {
      packages.forEach(pp => {
        qty += pp.package_quantity
      })
    }

    return qty
  }
  const CustomInvoiceTable = () => {
    return <table className='custom-invoice-table'>
      
      <tr className='report-header'>
        <td colSpan={5}>Delivery Invoice</td>
      </tr>
      <tr className='report-header'>
        <td>S/N</td>
        <td>Description</td>
        <td>Price (S$)</td>
        <td>Qty</td>
        <td>Amount (S$)</td>
      </tr>
      {previewData && <tr>
        <td>1</td>
        <td>Delivery Service for {moment(startDate).format(apiUtil.getImportDateFormat())} - {moment(endDate).format(apiUtil.getImportDateFormat())}</td>
        <td>{previewData && previewData.subtotal && parseFloat(previewData.subtotal) > 0 ? apiUtil.getCurrencyFormat(previewData.subtotal) : '-' }</td>
        <td>1</td>
        <td>{previewData && previewData.subtotal && parseFloat(previewData.subtotal) > 0 ? apiUtil.getCurrencyFormat(previewData.subtotal) : '-' }</td>
       </tr>
      }
      {previewData && <tr>
        <td>2</td>
        <td>Volume Discount {previewData && previewData.discount ? "( " + previewData.discount + " )  " : '-' } </td>
        <td>({previewData && previewData.discount ?  apiUtil.getCurrencyFormat(previewData.discount_amount) : '-' })</td>
        <td>1</td>
        <td>({previewData && previewData.discount ?  apiUtil.getCurrencyFormat(previewData.discount_amount) : '-' })</td>
       </tr>
      }
      <tr>
        <td colSpan={4} className="botom-cell-style">Subtotal</td>
        <td>{previewData && previewData.subtotal && parseFloat(previewData.subtotal) > 0 ? apiUtil.getCurrencyFormat( parseFloat(previewData.subtotal) - parseFloat(previewData.discount_amount)) : '-' }</td>
      </tr>
      <tr>
        <td colSpan={4} className="botom-cell-style">GST (9%)</td>
        <td>{previewData && previewData.gst_amount && parseFloat(previewData.gst_amount) > 0  ?  apiUtil.getCurrencyFormat(previewData.gst_amount): '-' }</td>
      </tr>
      <tr>
        <td colSpan={4} className="botom-cell-style">AMOUNT DUE TO US</td>
        <td>{previewData && previewData.invoice_amount && parseFloat(previewData.invoice_amount) > 0  ? apiUtil.getCurrencyFormat(previewData.invoice_amount) : '-' }</td>
      </tr>
    </table>
  }

  /* EXPORT API */
  const callExportInvoicePDF = () => {

    let pdf = new jsPDF("p", "mm", "a4");

    let index = 0;
    // let data = row?[row]:data;  
    
      if(index!= 0 ){  pdf.addPage(); }
        pdf.addImage(evfyLogo, 'PNG',10,8, 60, 24);
        pdf.setFont("verdana","bold","800");
        pdf.setFontSize(12);
        pdf.text(110,12, 'Evfy Pte Ltd');  

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,17, "84 Genting Lane");
        pdf.text(110,22, "#02-02");
        pdf.text(110,27, "Singapore 349584");
        pdf.text(110,32, "ACRA No.: 202121256D");
        pdf.text(110,37, "Email: hello@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(10);
        pdf.setFont("verdana","bold","800");
        pdf.text(10,48, 'Company Name'); 
        pdf.text(10,53, 'Email Address'); 

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        let primary_address_1 = "Primary Address Line 1		";
        let primary_address_2 = "Primary Address Line 2		";
        let primary_address_3 = "Primary Address Line 3		";
        pdf.text(10,58, primary_address_1); 
        pdf.text(10,63, primary_address_2); 
        pdf.text(10,68, primary_address_3); 

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,37, "Email: hello@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(140,53, "From");
        pdf.text(170,53, "To");

        pdf.setFont("verdana","bold","800");
        pdf.text(110,58, "Period:");
        pdf.text(110,63, "Invoice Number:");
        pdf.text(150,63, "	EVFY_year/mth/running no.	");
        pdf.text(110,68, "Date of Invoice:");

        pdf.autoTable({ 
          head: [ [{content: 'Delivery Invoice', colSpan:8,
                  styles: { halign: "center"}}],
                ['S/N', 'Date', 'Order Number', 'Job Type', 'Qty', 
                'Base Charge (SGD)', 'Surcharges (SGD)', 'Amount (SGD)']],
          body: [
            ['1', '', '', '', '', '' ,'', '$0.0'],
            ['2', '', '', '', '', '' ,'', '$0.0'],
            ['3', '', '', '', '', '' ,'', '$0.0'],
            ['4', '', '', '', '', '' ,'', '$0.0'],
            ['5', '', '', '', '', '' ,'', '$0.0'],
            [{content: 'This is an auto-generated invoice by Evfy Pte Ltd. For discrepencies, please contact us at 89323141', colSpan:6, 
            styles: { halign: "left", lineWidth: 0 }},
            {content: 'Discount (%)', colSpan:1, 
              styles: { halign: "right", lineWidth: 0 }
            }, '0 %'],
            [{content: 'Subtotal', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'GST', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'AMOUNT DUE TO US', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
          ],
          margin: { horizontal: 10, top: 75 },
          styles: { overflow: "linebreak" },
          bodyStyles: { valign: "top", halign: "center" },
          headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
          columnStyles: { email: { columnWidth: "wrap" } },
          theme: "grid",
            });

            pdf.autoTable({ 
            body: [
              [{content: 'The terms of payment shall be no later than 30 days from the date of invoice. For Cheque payment, please issue in favour of Evfy Pte Ltd For bank transfer payment: UOB 375-311-528-3', rowSpan:4,
              styles: { halign: "left", lineWidth: 0}}, {content: 'Official Use', colSpan:2,
              styles: { halign: "left"}}],
              [ {content: 'Status :', styles: { halign: "left"}}, 
                {content: 'Unpaid', rowSpan:3, styles: { halign: "left", fillColor: '#c3c3c3',}}],
                [{content: 'Mode:', styles: { halign: "left"}}], 
                [{content: 'Reference:', styles: { halign: "left"}}] 
            ],
            margin: { horizontal: 10, top: 75 },
            styles: { overflow: "linebreak" },
            bodyStyles: { valign: "top", halign: "center" },
            headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
            columnStyles: { 
              email: { columnWidth: "wrap" }, 
              0: {
                columnWidth: 120 },
              1: {
                columnWidth: 'auto' } },
            theme: "grid",
              });


        pdf.save(`Invoice.pdf`);
  }
  /* END EXPORT API */

  /* DIALOG */
  const CustomDialogPopup = () => {
    return <CustomDialog 
      open={openDialog}
      title={'Delete'}
      onClose={() => {
        setOpenDialog(false);
        setOpenDialogItem(null);
      }}
      onOk={() => {
        setOpenDialog(false);
        let row = openDialogItem; 
        callDeleteApi(row, () => {
          setOpenDialogItem(null);
          callReadApi(searchVal);
          apiUtil.toast('Successfully Deleted', 'check_circle');
        });
      }}
    >
      <Box>Are you sure you want to delete?</Box>
    </CustomDialog>
  }

  const invoicePreviewDialog = () => {
    return <CustomDialog
            open={openInvoicePreviewDialog}
            maxWidth={"md"}
            title={"Invoice Preview"}
            isLoading={isLoading}
            onClose={() => {
              let checkEmail = false;
              if(multiBillingEmail.length > 0) {
                let email_list = multiBillingEmail
                let valid_email = [];
                email_list.map((email) => {
                  if(email != '' && !apiUtil.emailValidation(email)) {
                    checkEmail = true;
                  } else {
                    valid_email.push(email);
                  }                      
                })
                if(checkEmail) {
                  setMultiBillingEmail(valid_email);
                  apiUtil.toast('Invalid email address',  'warning', 'error');
                  return;   
                }
              }
              setCustomerPhone(null)
              setCustomerEmail(null)
              setCustomerAddress(null)
              setInvoiceNumber(null)
              setInvoiceNew(null)
              setPreviewData(null)
              setOpenInvoicePreviewDialog(false);
            }}
            onOk={() => {
              let checkEmail = false;
              if(multiBillingEmail.length > 0) {
                let email_list = multiBillingEmail
                let valid_email = [];
                email_list.map((email) => {
                  if(email != '' && !apiUtil.emailValidation(email)) {
                    checkEmail = true;
                  } else {
                    valid_email.push(email);
                  }                      
                })
                if(checkEmail) {
                  setMultiBillingEmail(valid_email);
                  apiUtil.toast('Invalid email address',  'warning', 'error');
                  return;   
                }
              }
              if(checkEmail == false) {
                setOpenInvoicePreviewDialog(false); 
                callCreateApi((result)=> {
                  if(result) {
                    apiUtil.toast("Successfully Created", "check_circle")
                    setCustomerPhone(null)
                    setCustomerEmail(null)
                    setCustomerAddress(null)
                    setInvoiceNumber(null)
                    setInvoiceNew(null)
                    setPreviewData(null)
                    setCustomerId(null)
                    setDepartment(null)
                    setBillingDate(null)
                    setBillingEamil(null)
                    setCcEmails('')
                    setNotifyCustomer(true)
                    setPdfUlr(null)
                    setKey(Date.now());
                    setInvoiceDialog(false)
                    setRaneDate(null)
                    setStartDate(null)
                    setEndDate(null)
                    setMultiBillingEmail([]);
                    setBillingEmail('')
                    setIsValid(true);
                    callReadApi()
                
                  }
                })
              }
            }}
            >
              <Box>
                <form  noValidate >
                <Row className='mb-4'>
                  <Col xs={12} md={6}>
                    <div>
                    { userInfo && userInfo.company_logo ? <img src={ userInfo.company_logo } alt="company logo" style={{height: '120px'}}/>
                      : <div style={{fontSize: "50px"}}>LOGO</div>}

                    </div>
                    <div className='mt-5 custom-input-component'>
                    <div className='report-header'>{previewData && previewData.customer ? previewData.customer.company_name : "" }</div>
                    <div className='report-title'>{previewData && previewData.department ? previewData.department.name : "" }</div>
                    <div className='my-2'>
                      <CustomInput type="text" className='col-6' placeholder='phone number'
                      value={customerPhone}
                      onChange={e => setCustomerPhone(e.target.value)}
                      />
                    </div>
                    <div className='my-2'>
                      
                      <CustomInput type="email"  className='col-6 '  placeholder='Email'
                      
                      value={multiBillingEmail.join(',')}
                      onBlur={() => {
                        //const email_list = customerEmail.split(',')
                        //if(!email_list.filter((email) => email && !apiUtil.emailValidation(email)).length > 0) {
                        //  setMultiBillingEmail(email_list.filter((e) => e != '')); 
                        //}                        
                      }}
                      onChange={e=> {
                        setMultiBillingEmail(e.target.value.split(','))
                      }}
                      />
                    </div>
                    <div className='my-2'>
                      <CustomInput rows={5} className='col-6'  type="text" placeholder='Address' 
                      
                      value={customerAddress}
                      multiline={true}
                      onChange={e=>setCustomerAddress(e.target.value)}
                      />
                    </div>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className='pe-4'>
                    <div>
                    <div className='report-header'>{userInfo ? userInfo.company_name : '' }</div>
                    <div >{userInfo && userInfo.address ? userInfo.address.split(',')[0] : '' }</div>
                    <div >{userInfo && userInfo.address ? userInfo.address.split(',')[1] : '' }</div>
                    <div >{userInfo && userInfo.address ? userInfo.address.split(',')[2] : '' }</div>
                    <div >{userInfo && userInfo.address ? userInfo.fax_no : '' }</div>
                    <div >Email : {userInfo ? userInfo.email: '' } </div>
                    <div >Phone : {userInfo ? userInfo.contact_no: '' } </div>
                    </div>
                    <div className='mt-5 custom-input-component'>
                      <table style={{width: "80%"}}>
                        <tr>
                          <td></td>
                          <td className='report-header' style={{width: "30%"}}>From</td>
                          <td className='report-header' style={{width: "30%"}}>To</td>
                        </tr>
                        <tr>
                          <td className='report-header'>Peroid:</td>
                          <td >{moment(startDate).format(apiUtil.getImportDateFormat())}</td>
                          <td>{moment(endDate).format(apiUtil.getImportDateFormat())}</td>
                        </tr>
                        <tr>
                          <td className='report-header'>Invoice Number:</td>
                          <td colSpan={2}>
                            <CustomInput type="text" placeholder='Invoice Number' 
                            value={invoiceNumber}
                            onChange={e=>{
                              setInvoiceNumber(e.target.value)
                            }
                            }
                          />
                          </td>
                        </tr>
                        <tr>
                          <td className='report-header'>Invoice Date</td>
                          <td colSpan={2}> {previewData && moment(previewData.due_date).format(apiUtil.getImportDateFormat())}</td>
                        </tr>
                      </table>
                      <div className='col-4'></div>
                    </div>
                  </Col>
                  <Col xs={12} md={12} className='mt-4 pe-4'>
                  <CustomInvoiceTable key={"customInvoiceTable"}/>
                </Col>
                </Row>
               
                </form>
              </Box>

              

            </CustomDialog>
  }
  const callUploadFilesApi = async (file, fName) => {

    let result = "";

    setIsUploading(true)
    setProgress(0)

    if(file){
        let fileExt = fName.split('.').pop();
        let filename = fName.substr(0, fName.lastIndexOf("."))
        
        let getResult = await Api.uploadFile(
            'upload',
            file, 
            'AUTH',
            'customer/invoices', 
            filename,
            fileExt,
            accessToken, 
            (progress) => {
                setProgress(progress)
            }
        );

        apiUtil.parseResult(getResult, (data) => {
          if(data.status) {
            setPdfUlr(data.result.image_medium_url)
          }
        }, (error) => {
            apiUtil.toast(error, 'check_circle', 'error');
        });

        setIsUploading(false)
        setProgress(null)
    } else {
        apiUtil.toast('Please select a file!', 'check_circle', 'error');
    }

    return result;
}

  const NewInvoiceDialog = () => {
    return <CustomDialog2 
      open={invoiceDialog}
      title={ resentMail != '' ? 'Send Invoice' : ' Create New Invoice'}
      zIndexNumber={"z-index-1200 client-invoice-dialog"}
      hideCancelButtons={true}
      maxWidth={'md'}
      //isLoading={isUploading ? isUploading : isLoading}
      onClose={() => {
        setInvoiceDialog(false);
        setResentMail('')
        setCustomerId(null)
        setDepartment('')
        setBillingDate(null)
        setBillingEamil('')
        setCcEmails('')
        setNotifyCustomer(true)
        setPdfUlr(null)
        setKey(Date.now());
        setRaneDate(null)
        setStartDate(null)
        setEndDate(null)
        setMultiBillingEmail([]);
        setBillingEmail('')
        setIsValid(true);
      }}
      onOk={() => {
        if(customerId == null ) {
          apiUtil.toast('Please select a customer!', 'check_circle', 'error')
          return
        }

        

        callCreateApi(()=>{
          callReadApi()
        })
        setCustomerId(null)
        setDepartment('')
        setBillingDate(null)
        setBillingEamil('')
        setCcEmails('')
        setNotifyCustomer(true)
        setPdfUlr(null)
        setKey(Date.now());
        setRaneDate(null)
        setStartDate(null)
        setEndDate(null)
        setInvoiceDialog(false);
        setMultiBillingEmail([]);
        setBillingEmail('')
        setIsValid(true);
      }}
      hideOkButtons={true}
    >
      <Box>
        <Row>
          <Col xs={12} md={6} className="d-flex justify-content-end py-2 align-items-center max-xs-width-control-900">
          <div className="col-12 col-xs-12 col-md-4 col-lg-4 text-end max-xs-width-control-900">Company Name</div>
          <div className="col-12 col-xs-12 col-md-8 col-lg-8 max-xs-width-control-900">
          <Form.Select aria-label="Default select example" className='ms-2'
          disabled={isLoading == true || isUploading == true || resentMail != '' ?  true : false}
          value={customerId}
          onChange={e=> {
            let customer_id = e.target.value
            let customer = customers.filter(c => c.id == customer_id).length > 0 ? customers.filter(c => c.id == customer_id)[0]: null
            setCustomer(customer) 
            setCustomerId(customer_id)
            // setDepartment(customer && customer.departments && customer.departments.length > 0 ? customer.departments[0].id : '')
            if(customer && customer.company_email) {
              let emails = customer.company_email.split(',')
              setMultiBillingEmail(emails);
            } else {
              setMultiBillingEmail([]);  
            }
            //setBillingEamil(customer && customer.company_email ? customer.company_email : '')
          }}
          >
            <option value= '' >Select Customer</option>
            {customers.length > 0 && customers.map((cu)=> (
                <option value={cu.id} key={cu.id}>{cu.company_name}</option>
            ))}
          </Form.Select>
          </div>
          </Col>
          <Col xs={12} md={6} className="d-flex justify-content-end py-2 align-items-center max-xs-width-control-900">
            <div className="col-12 col-xs-12 col-md-4 col-lg-4 text-end max-xs-width-control-900">Department</div>
            <div className="col-12 col-xs-12 col-md-8 col-lg-8 max-xs-width-control-900">
            <select className="max-xs-width-control-900 form-control ms-2" style={{width:"100%", border: "1px solid #E0E1E4", borderRadius: "4px",padding:"", backgroundColor: 'transparent'}}
                placeholder={'Select Department here...'}
                disabled={isLoading == true || isUploading == true || resentMail != ''  ?  true : false}
                value={department}
                native
                disableUnderline
                onChange={(e) => {
                 setDepartment(e.target.value);
                }}
              >
          <option value="" selected> Select Department </option>
          {customer && customer.departments.map((dd, index)=> 
            <option value={dd.id}>{dd.name}</option>
          )}
        </select>
        {/* <input type="text" value={department} className="form-control ms-2" disabled/> */}
            </div>
          </Col>
          <Col xs={12} md={6} className="d-flex justify-content-end py-2 max-xs-width-control-900">
            <div className="col-12 col-xs-12 col-md-4 col-lg-4 text-end max-xs-width-control-900 mt-2">Billing Email</div>
            <div className="col-12 col-xs-12 col-md-8 col-lg-8 max-xs-width-control-900 position-relative">
              <input type="text" className="form-control ms-2" 
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
              placeholder='Enter billing email...'
              value={billingEmail}/>
              <span style={{position:'absolute', right: '-45px', top: '-10px'}}>
                <CustomCheckbox 
                  value={notifyCustomer}
                  checked={notifyCustomer}
                  onChange={e => {
                    setNotifyCustomer(!notifyCustomer)
                  }}
                />
                <span style={{ fontSize: '9px', position: 'absolute', right: '7px', top: '32px'}}>Notify</span>
              </span>
              {multiBillingEmail.length > 0 && <div className="multi-email-container">
                {multiBillingEmail.map((value, index) => (
                  <div key={index} className="email-item">
                    <span>{value}</span>
                    <button onClick={() => handleValueDelete(value)}>&times;</button>
                  </div>
                ))}
              </div>
              }
            </div>
          </Col>
          <Col xs={12} md={6} className="d-flex justify-content-end py-2 align-items-center max-xs-width-control-900">
            <div className="col-12 col-xs-12 col-md-4 col-lg-4 text-end max-xs-width-control-900">Invoice Date</div>
            <div className="col-12 col-xs-12 col-md-8 col-lg-8 max-xs-width-control-900">
            <input className="form-control ms-2"
            type="date"
            disabled={isLoading == true || isUploading == true || resentMail != ''  ?  true : false}
            value={billingDate}
            onChange={e => {
              setBillingDate(e.target.value)
            }}
            />
            </div>
          </Col>
          <Col xs={12} md={12} className="d-flex justify-content-end py-2 max-xs-width-control-900">
          <div className="col-12 col-xs-12 col-md-2 col-lg-2 text-end max-xs-width-control-900 mt-2">CC Emails</div>
          <div className="col-12 col-xs-12 col-md-10 col-lg-10 max-xs-width-control-900">
          <input type="text" className="form-control ms-2"
          disabled={multiBillingEmail.length == 0 || isLoading == true || isUploading == true ? true : false} 
          value={ccEmails}
          onChange={e=>setCcEmails(e.target.value)}
          />
          <small className='ms-2 text-muted'> Split CC Emails with comma </small>
          </div>
          </Col>
          {/* <Col xs={12} md={6} className="d-flex justify-content-end py-2 align-items-center max-xs-width-control-900">
            <div className="col-12 col-xs-12 col-md-4 col-lg-4 text-end max-xs-width-control-900">Notify Customer</div>
            <div className="col-12 col-xs-12 col-md-8 col-lg-8 max-xs-width-control-900">
              <CustomCheckbox 
              value={notifyCustomer}
              disabled={isUploading}
              onChange={e => {
                setNotifyCustomer(!notifyCustomer)
              }}
              />
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col xs={12} md={6} className="d-flex justify-content-end py-2 align-items-center max-xs-width-control-900">
              <div className="col-12 col-xs-12 col-md-4 col-lg-4 text-end max-xs-width-control-900">Invoice Period</div>
              <div className="col-12 col-xs-12 col-md-8 col-lg-8 ps-1 max-xs-width-control-900">
              <CustomDateRangePicker
                  className="w-100"
                  disabled={pdfUrl || isLoading == true || isUploading == true || resentMail != ''  ? true: false}
                  range={rangeDate}
                  onChange={(range) => {
                    setRaneDate(range)
                    setStartDate(range.startDate)
                    setEndDate(range.endDate)
                  }}
                />
                </div>
            </Col>
           
          <Col xs={12} md={6} className="d-flex justify-content-end py-2 align-items-center max-xs-width-control-900">
            <div className="col-12 col-xs-12 col-md-1 col-lg-1 text-center max-xs-width-control-900 px-2">or</div>
            <div className="col-12 col-xs-12 col-md-3 col-lg-3 text-end max-xs-width-control-900">Upload CSV or Excel file:</div>
            <div className="col-12 col-xs-12 col-md-8 col-lg-8 ps-1 max-xs-width-control-900">
            <input type="file"  className="form-control flip-form"
              key={key}
              disabled={(startDate || endDate) || isLoading == true || isUploading == true || resentMail != ''  ? true: false }
              accept="application/pdf"
              onChange={e=>{
                if(e.target.value !=='') {
                  let file_name = e.target.files[0].name
                  let reader = new FileReader();
                  reader.onload = function(e) {
                    let result = e.target.result
                    let blob = dataUrlToBlob(result)
                    callUploadFilesApi(blob, file_name)
                  };
                  reader.readAsDataURL(e.target.files[0]);
                } else {
                  setKey(Date.now());
                  setPdfUlr(null)
                }
                setCustomerEmail(multiBillingEmail.join(','));
              }}/></div>
            </Col>
          </Row>
          <Row>
              <Col  xs={12} className="d-flex justify-content-center align-items-center  mt-2" >
              <Button className="upload-style"
                  onClick={() => {
                  
                    if (resentMail == '' || resentMail == null) {
                      if(customerId == null || customerId == '') {
                        apiUtil.toast('Please select a customer!', 'check_circle', 'error')
                        return
                      }
  
                      if(startDate == null && pdfUrl == null) {
                        apiUtil.toast('Please select invoice period or upload PDF!', 'check_circle', 'error')
                        return
              
                      }
                    }
                    
                    
                    if(ccEmails) {
                      let cc_emails = ccEmails.split(',')
                      let invalidCcEmails = [] 
                      cc_emails.forEach(cc => {
                        if (!apiUtil.emailValidation(cc.trim())) {
                          invalidCcEmails.push(cc)
                        }
                      })
                      if(invalidCcEmails.length > 0) {
                        apiUtil.toast(`CC email ${invalidCcEmails} are invalid.`, 'check_circle', 'error')
                        return
                      }
                    }
                    let is_preview = pdfUrl ? false : true
                    resentMail != ''  ? 
                    callResendApi(resentMail, (result)=>{
                      if(result) {
                        apiUtil.toast("Successfully Resend Mail", "check_circle")
                        setCustomerId(null)
                        setDepartment(null)
                        setBillingDate(null)
                        setBillingEamil(null)
                        setPdfUlr(null)
                        setKey(Date.now());
                        setCcEmails('')
                        setInvoiceDialog(false)
                        setRaneDate(null)
                        setStartDate(null)
                        setEndDate(null)
                        setResentMail('')
                        setMultiBillingEmail([]);
                        setBillingEmail('')
                        setIsValid(true);
                        callReadApi()
                      }
                      
                    })
                    :
                    callCreateApi((result)=>{
                      if(result) {
                        if (is_preview) {
                          setCustomerPhone(result.customer ? result.customer.contact_no1 : '')
                          setCustomerEmail(multiBillingEmail.join(','))
                          setCustomerAddress(result.customer && result.customer.customer_addresses ? result.customer.customer_addresses[0]['address_line1'] : '')
                          setInvoiceNumber(result.invoice_number ? result.invoice_number : '')
                          setInvoiceNew(result.invoice_number ? result.invoice_number : '')
                          setPreviewData(result)
                          setOpenInvoicePreviewDialog(true)
                          return
                        }
                        apiUtil.toast("Successfully Created", "check_circle")
                        setCustomerId(null)
                        setDepartment(null)
                        setBillingDate(null)
                        setBillingEamil(null)
                        setPdfUlr(null)
                        setKey(Date.now());
                        setCcEmails('')
                        setInvoiceDialog(false)
                        setRaneDate(null)
                        setStartDate(null)
                        setEndDate(null)
                        setMultiBillingEmail([]);
                        setBillingEmail('')
                        setIsValid(true);
                        callReadApi()
                      }
                      
                    }, is_preview)
                    
                  
                    
                  }}
                  disabled={isUploading? isUploading: isLoading? isLoading: false}
                >{isUploading || isLoading? <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> :( resentMail != ''  ? "Send Email" : "Generate Invoice")}</Button>
              </Col>
          </Row>
          
      </Box>
    </CustomDialog2>
  }
  


  return <Container fluid>
     <Card className="overflow-hidden custom-card-margin-x">
          <div className="row border-0 m-0">
            <div className="col-xs-12 col-md-6 d-flex justify-content-start align-items-center mb-2">
            <div className="row d-flex max-xs-width-control justify-content-start align-items-center mb-2">
                <div className="col-xs-12 col-md-6 my-2">
                <CustomInput
            className="input-custom-style"
             ref={refTableSearch}
              placeholder={'Search Client'}
              value={searchVal}
              onChange={e=>{
                setSearchVal(e.target.value)
              }}
              onPressEnter={(e) => {
                setSearchVal(refTableSearch.current.state.value);
                setPage(1);
                callReadApi(searchVal, 1) 
              }}
            />
            </div>
            <div className="col-xs-12 col-md-6 my-2 d-flex justify-content-center align-items-center">
            <Button className="upload-style w-100 max-height-btn" onClick={(e) => {
                    setPage(1);
                    callReadApi(searchVal, 1) 
                  }}><FontAwesomeIcon icon={faMagnifyingGlass} className="text-white" style={{color:'#ffffff'}}/> Search</Button>
            </div>
            </div>
            </div>
            <div className="col-xs-12 col-md-6 d-flex justify-content-end align-items-center mb-2">
              {/* <Button className="justify-self-end d-flex ms-auto upload-style-border cd-shadow">Import Customer</Button> */}
              {(grantedAccess.isPermissionActionAllowed(currentRole, 'Client Driver Invoice Add') && currentRole != 'BD Admin' && currentRole != 'Ops Admin') && <Button className="justify-self-end upload-style" onClick={() => {
                setInvoiceDialog(true);
              }}><FontAwesomeIcon icon={faPlus} /> New Invoice</Button>}
            </div>
          </div>
      </Card> 
      {grantedAccess.isPermissionActionAllowed( currentRole, 'Client Driver Invoice List') && 
          <Card className="overflow-hidden custom-card-margin-x">
            <CustomTable /> 
          </Card>}
    <CustomDialogPopup />
    {NewInvoiceDialog()}
    {invoicePreviewDialog()}
  </Container>;
}